import { Helmet } from 'react-helmet-async';

export const GlobalSeo: React.FC = () => {
  return (
    <Helmet>
      <meta property="og:title" content="Универмаг «Цветной»" />
      <meta
        property="og:description"
        content="Концептуальный Универмаг в историческом центре Москвы. Одежда, обувь, косметика, книги, предметы мебели и аксессуары. Круглосуточная парковка."
      />
      <meta property="og:image" content="/preview.webp" />
      <title>Цветной</title>
    </Helmet>
  );
};
